<template>
  <main class="view max-w-half">
    <div class="content pad">
      <router-link
        :to="{ name: 'article', params: { uid: article.uid } }"
        v-for="article in articles"
        :key="article.uid"
      >
        <h1>{{ article.title }}</h1>
        <p class="">{{ article.author }} / {{ article.date }}</p>
      </router-link>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "articles",
  metaInfo: {
    title: "– Articles",
  },
  computed: mapState(["articles"]),
};
</script>
